const generateOrderNo = (rules: number[]) =>
	rules.reduce((max, orderNo) => Math.max(max, orderNo), 0) + 1;

export { generateOrderNo };
